/**
 * <s-countdown data-end="ISO date"> ticks the [data-unit] children down to the end time,
 * then hides itself so an expired sale never shows zeros.
 */
class CountdownElement extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    if (Number.isNaN(this.end)) {
      this.hidden = true;
      return;
    }
    this.units = {};
    for (const node of this.querySelectorAll('[data-unit]')) {
      this.units[node.dataset.unit] = node;
    }
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    const remaining = this.end - Date.now();
    if (remaining <= 0) {
      clearInterval(this.timer);
      this.hidden = true;
      return;
    }
    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const node = this.units[unit];
      if (node) node.textContent = String(value).padStart(2, '0');
    }
    this.hidden = false;
  }
}

if (!customElements.get('s-countdown')) {
  customElements.define('s-countdown', CountdownElement);
}
